function AppHeader() {
  return (
    <header className="bg-blue-600 text-white p-4">
      <h1 className="text-2xl font-bold">My Web-Based Wallet</h1>
    </header>
  );
}
export default AppHeader;
